import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./Homepage.css";
import { createSlug } from "../../utils/slugify";
import ApiService from "../Services/ApiServices";

function HomepageProducts() {
  const [session2, setSession2] = useState([]);
  const [devicesDetails, setDevicesDetails] = useState([]);

  console.log(devicesDetails,"all devices details")


  // Fetch promotions from backend
  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const payload = {
          companyCode: "WAY4TRACK",
          unitCode: "WAY4",
        };

        const allDevicesData = await ApiService.post("device/getAllDevices", payload)

        const response = await ApiService.post(
          "promotion/getAllPromotions",
          payload
        );
        const data = response.data.data || [];

        

        // Filter for latest Session-2 promotions
        const latestSession2 = data
          .filter((item) => item.theme === "Session-2")
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];

        setSession2(latestSession2?.list || []);
        setDevicesDetails(allDevicesData?.data)
      } catch (error) {
        console.error("Error fetching promotions:", error);
      }
    };

    fetchPromotions();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // const createSlug = (text) => {
  //   return text
  //     ?.toLowerCase()
  //     .trim()
  //     .replace(/&/g, "and")
  //     .replace(/[^a-z0-9\s-]/g, "")
  //     .replace(/\s+/g, "-")
  //     .replace(/-+/g, "-")
  //     .replace(/^-|-$/g, "");
  // };

  return (
    // <div className="homepage-products">
    <div className="homepage-products-scroll-container">
      <div className="homepage-products-scroll">
        {devicesDetails?.map((item, index) => {
          // const deviceId = new URLSearchParams(
          //   item.link?.split("?")[1]
          // ).get("deviceId");

          return (
            <div key={index} className="homepage-product-card">
              <Link
                // to={`/products/${createSlug(item.name)}-${deviceId}`}
                to={`/products/${createSlug(item.name)}`}
                className="homepage-product-card-link"
                onClick={scrollToTop}
              >
                <img
                  src={item.image[0] || ""}
                  alt={item.name || `Product ${index + 1}`}
                />

                <div className="center-wrapper">
                  <h3 className="home-product-heading">
                    {item.name || "Unnamed Product"}
                  </h3>

                  <p className="home-product-p">{item.description}</p>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default HomepageProducts;
